import React from 'react';
import { Form, App } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useMutation } from '@apollo/client';
import { PLAN_CREATE } from '../../../graphql/mutations/plans';
import { PlanForm } from '../../../components/Plans/PlanForm';
import CardLayout from '../../../layouts/CardLayout';
import { IPlan, PlanFormValues, IPlanPhotoForm } from '../../../types/plans';

export const PlanCreate: React.FC = () => {
  const { message } = App.useApp();
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const [createPlan, { loading: createLoading }] = useMutation(PLAN_CREATE, {
    onCompleted: (data: { planCreate: IPlan }) => {
      console.log(data.planCreate.id);
      message.success('Plan successfully created');
      navigate(`/admin/plan/${data.planCreate.id}`);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    onError: error => {
      message.error(error.message);
    },
  });

  const onFinish = async (values: PlanFormValues) => {
    try {
      const photos = values.photos?.map((photo: IPlanPhotoForm) => ({
        original: photo.url,
        isPublish: photo.selected,
        isPrimary: !!photo.isPrimary,
        size: photo.size || 0,
        type: photo.type || '',
        tags: photo.tags || [],
        compressed: photo.compressed && {
          url: photo.compressed.url,
          size: photo.compressed.size || 0,
          type: photo.compressed.type || '',
          watermarked: photo.compressed.watermarked || false,
        },
      }));
      const image = (Array.isArray(values.image) && values.image[0]?.url) || '';
      const createData = {
        ...values,
        planCost: values.planCost ? Number(values.planCost) : 0,
        fixPrice: values.fixPrice ? Number(values.fixPrice) : 0,
        photos,
        image,
      };
      if (!createData.preApproved) {
        createData.preApprovedArea = {
          states: [],
          counties: [],
          cities: [],
        };
      }
      await createPlan({
        variables: createData,
      });
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <CardLayout>
      <PlanForm form={form} onFinish={onFinish} loading={createLoading} submitText="Create Plan" />
    </CardLayout>
  );
};
